import {Badge} from '@/components';
import {dateTimeInTimeZone} from '@/utils/date';

import type {DeliveryRowProps} from './types';

export const DeliveryRow = ({
  delivery,
  isActive,
  onSelect,
}: DeliveryRowProps) => (
  <button
    type="button"
    onClick={() => onSelect(delivery.webhookId, delivery.attempt)}
    data-testid="delivery-row"
    className={`w-full text-left border-b border-gray-100 dark:border-dark-borderMid p-3 transition-colors hover:bg-gray-50 dark:hover:bg-dark-inputBg ${
      isActive ? 'bg-blue-50 dark:bg-blue-700' : ''
    }`}
  >
    <div className="flex items-start justify-between gap-2">
      <span className="font-mono text-xs text-gray-900 dark:text-gray-100 truncate">
        {delivery.event}
      </span>
      <Badge
        colorScheme={delivery.status === 'SUCCESS' ? 'successful' : 'failed'}
        label={delivery.status}
      />
    </div>
    <div className="flex items-center justify-between mt-1 text-xs text-gray-400 dark:text-gray-500">
      <span className="truncate">{dateTimeInTimeZone(delivery.timestamp)}</span>
      <span className="shrink-0 ml-2">
        #{delivery.attempt}
        {delivery.responseTime !== undefined &&
          ` · ${delivery.responseTime.toFixed(2)}ms`}
      </span>
    </div>
  </button>
);
